import { render } from "./index.vue?vue&type=template&id=053e78c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&id=053e78c6&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=053e78c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-053e78c6"

export default script